export function getDimensionsOfHidden(element: HTMLElement, displayMode?: string): { width: number, height: number } {
    const el = element as HTMLElement;
    const parent = el.parentElement!;
    const parentStyles = parent.getAttribute('style');
    const selfStyles = el.getAttribute('style');
    displayMode = displayMode ?? "inline-block";
    parent.setAttribute('style', 'position: relative !important; width: 100% !important;');
    el.setAttribute('style', `display: ${displayMode} !important; opacity: 0 !important; height: auto !important; position: absolute !important;`);

    const boundingRect = element.getBoundingClientRect();
    const elementwidth = boundingRect.width;
    const elementHeight = boundingRect.height;
    if (selfStyles) {
        el.setAttribute('style', selfStyles);
    }
    else {
        el.removeAttribute('style');
    }
    if (parentStyles) {
        parent.setAttribute('style', parentStyles);
    }
    else {
        parent.removeAttribute('style');
    }
    return { width: elementwidth, height: elementHeight };
}